let lmtypes = [
  "Full Service",
  "Regular Service",
  "Corporate Full Service",
  "Corporate Regular Service",
];
export default lmtypes;
